import Breakdown from "./breakdown";
const Breakpg = () => {
    return (
              <div className="">
                <Breakdown></Breakdown>
              </div>
            );
          }
export default Breakpg;
          